import LegalPageLayout from "@/components/landing/LegalPageLayout";

const TermsOfService = () => (
  <LegalPageLayout title="Terms of Service" lastUpdated="January 15, 2026">
    <section>
      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing or using Trust Wallet Card services ("Services"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, you must not use our Services. These Terms constitute a legally binding agreement between you and Trust Wallet Card.
      </p>
    </section>

    <section>
      <h2>2. Eligibility</h2>
      <p>To use our Services, you must:</p>
      <ul>
        <li>Be at least 18 years of age (or the age of majority in your jurisdiction)</li>
        <li>Have the legal capacity to enter into a binding agreement</li>
        <li>Have a connected cryptocurrency wallet</li>
      </ul>
      <p>
        No identity verification, KYC procedures, or documentation is required. Our service is fully decentralized and accessible to anyone with a compatible wallet.
      </p>
    </section>

    <section>
      <h2>3. Card Services</h2>
      <h3>Card Issuance</h3>
      <p>
        Trust Wallet Card is issued as a decentralized payment instrument linked directly to your cryptocurrency wallet. No bank approval or credit checks are required. Cards are available worldwide with no geographic restrictions.
      </p>

      <h3>Transaction Processing</h3>
      <p>
        When you make a purchase, the transaction amount is converted from your selected cryptocurrency to the local fiat currency at the prevailing market rate at the time of the transaction.
      </p>

      <h3>No Spending Limits</h3>
      <p>
        There are no daily, monthly, or annual spending limits imposed by the platform. You can spend as much as your wallet balance allows without any restrictions or caps.
      </p>
    </section>

    <section>
      <h2>4. Rewards Program</h2>
      <p>
        Eligible purchases earn crypto rewards at rates specified in the current Rewards Schedule. Rewards are credited to your connected wallet within 24 hours of the transaction settling.
      </p>
    </section>

    <section>
      <h2>5. Fees</h2>
      <ul>
        <li><strong>Annual Fee:</strong> $0 for all tiers</li>
        <li><strong>Foreign Transaction Fee:</strong> 0% on all international purchases</li>
        <li><strong>ATM Withdrawal Fee:</strong> $2.50 per withdrawal (first 5 per month free for Premium tier)</li>
        <li><strong>Card Replacement:</strong> $10 for Standard/Pro; free for Premium tier</li>
        <li><strong>Crypto Conversion Spread:</strong> 0.5% – 1.5% depending on asset and market conditions</li>
      </ul>
    </section>

    <section>
      <h2>6. User Responsibility</h2>
      <p>
        Users are solely responsible for ensuring their use of the platform complies with the laws and regulations of their jurisdiction. Trust Wallet Card is a decentralized tool and does not impose restrictions on how users spend their funds.
      </p>
    </section>

    <section>
      <h2>7. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, Trust Wallet Card shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the Services. We are not responsible for losses resulting from cryptocurrency price fluctuations.
      </p>
    </section>

    <section>
      <h2>8. Dispute Resolution</h2>
      <p>
        Any disputes arising from these Terms shall be resolved through binding arbitration administered by the International Centre for Dispute Resolution (ICDR) in accordance with its rules.
      </p>
    </section>
  </LegalPageLayout>
);

export default TermsOfService;
